module.exports = __webpack_public_path__ + "img/bg.7b624148.jpg";